import dayjs from "dayjs";

export function chartDateTodayStart() {
  return dayjs().startOf("day");
}

export function presetThisMonth() {
  const end = chartDateTodayStart();
  return { start: end.startOf("month"), end };
}

export function presetLastThreeMonths() {
  const end = chartDateTodayStart();
  return { start: end.subtract(3, "month").startOf("day"), end };
}

export function presetLastSixMonths() {
  const end = chartDateTodayStart();
  return { start: end.subtract(6, "month").startOf("day"), end };
}

export function presetLastYear() {
  const end = chartDateTodayStart();
  return { start: end.subtract(1, "year").startOf("day"), end };
}

export function dashboardChartRangesEqual(a, b) {
  if (a == null && b == null) return true;
  if (a == null || b == null) return false;
  return a.start.isSame(b.start, "day") && a.end.isSame(b.end, "day");
}
